import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { FaUpload } from "react-icons/fa";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  MenuItem,
  LinearProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Grid,
  FormHelperText,
} from "@mui/material";
import Match from "../../components/Match/Match";
import "./FileUpload.css";
//import api_base_url from "../../config";
import { setHeaderMapping } from "../../state/Match/matchSlice";
import {
  fetchJobTypes,
  setSelectedJobType,
  setErrorMessage,
  setFile,
  setProgress,
  toggleDialog,
  uploadJobData,
  submitMeetingDetails,
  resetUploadStatus,
} from "../../state/FileUpload/fileUploadSlice";
import { setColumnHeaders } from "../../state/Match/matchSlice";
import axios from "axios";
import axiosInstance from "../../../../api/axiosInstance";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { styled } from "@mui/system";
import { useLocation } from "react-router-dom";
// import MatchExisting from "../Match/MatchExisting";
// import MatchNew from "../Match/MatchNew";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiFormHelperText-root": {
    color: "#ff0f0f",
  },
}));

const commonStyles = {
  formControl: {
    width: 220,
    height: 55,
    borderRadius: "8px",
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#ab1368",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ab1368",
      },
      "&:hover fieldset": {
        borderColor: "#ab1368",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ab1368",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#ab1368",
    },
  },
  select: {
    width: 220,
    height: 55,
    borderRadius: "8px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ab1368",
      },
      "&:hover fieldset": {
        borderColor: "#ab1368",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ab1368",
      },
    },
    "& .MuiSelect-select": {
      color: "#ab1368",
    },
    "& .MuiSelect-icon": {
      color: "#ab1368",
    },
    "& .MuiMenuItem-root.Mui-selected": {
      color: "#ab1368",
    },
    "& .MuiMenuItem-root.Mui-selected:hover": {
      backgroundColor: "rgba(171, 19, 104, 0.08)",
    },
  },
  button: {
    backgroundColor: "#AB1368",
    width: "180px",
    color: "white",
    padding: "10px 30px",
    borderRadius: "5px",
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    marginTop: "10px",
    ":hover": {
      backgroundColor: "#8d0e56",
    },
  },
};

const FileUpload = () => {
  // Authorization is now handled at the route level in ChiesiRoutes

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownDisabled, setIsDropdownDisabled] = useState(
    location.state?.isDropdownDisabled || false
  );
  const { isAuthorised } = useSelector((state) => state.authentication);
  const loginState = useSelector((state) => state.authentication);
  const user_id = loginState.user.userId;
  const [selectedJobtype, setSelectedJobtype] = useState({
    id: "",
    jobType: "",
  });

  const [dialogContent, setDialogContent] = useState("");
  const [fileObject, setFileObject] = useState(null);
  const [meetingName, setMeetingName] = useState("");
  const [meetingId, setMeetingId] = useState("");
  const [subtype, setSubtype] = useState("");
  const [recordType, setRecordType] = useState("");
  const [startDateTime, setStartDateTime] = useState(
    dayjs().hour(12).minute(0)
  );
  const [endDateTime, setEndDateTime] = useState(dayjs().hour(17).minute(0));
  const [meetingStatus, setMeetingStatus] = useState("");
  const [deliveryFormat, setDeliveryFormat] = useState("");
  const [oceStatus, setOceStatus] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");
  const [comments, setComments] = useState("");
  const [estimatedParticipants, setEstimatedParticipants] = useState(0);
  const [errors, setErrors] = useState({});

  const {
    uploadedFile,
    errorMessage,
    uploadProgress,
    open,
    uploadJobDataStatus,
    uploadedJobId,
    existingjobDetails,
    uploadJobDataError,
  } = useSelector((state) => state.fileUpload);
  //const user_token = useSelector((state) => state.login.token);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [fileTypeErrorDialogOpen, setFileTypeErrorDialogOpen] = useState(false);

  const handleChange = (event) => {
    const selectedID = event.target.value;
    const selectedJob = jobType.find((item) => item.id === selectedID);
    if (selectedJob) {
      setSelectedJobtype(selectedJob);
    }
  };

  useEffect(() => {
    dispatch(setSelectedJobType(selectedJobtype));
  }, [selectedJobtype, dispatch]);

  const handleErrorDialogClose = () => {
    setErrorDialogOpen(false);
    dispatch(setHeaderMapping([]));
    // dispatch(resetUploadStatus());
  };

  const handleFileTypeErrorDialogClose = () => {
    setFileTypeErrorDialogOpen(false);
  };

  const handleClickOpen = () => {
    dispatch(toggleDialog());
  };

  const handleClose = () => {
    dispatch(toggleDialog());
  };

  const showAlert = () => {
    setFileTypeErrorDialogOpen(true);
    dispatch(resetUploadStatus());
  };

  const onDrop = useCallback(
    async (acceptedFiles) => {
      const file = acceptedFiles[0];
      const fileName = file.name;
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (fileExtension !== "xlsx" && fileExtension !== "csv") {
        showAlert();
        return;
      }

      try {
        const formData = new FormData();
        formData.append("file", file);

        const headers = {
         // Authorization: `Bearer ${user_token}`,
          "Content-Type": "multipart/form-data",
        };

        const response = await axiosInstance.post(
          `/api/Jobs/retrieveColumnHeaders`,
          formData,
          {
            headers,
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              dispatch(setProgress(progress));
            },
            timeout: 60000,
          }
        );

        dispatch(setColumnHeaders(response.data));

        dispatch(setFile({ name: fileName }));
        setFileObject(file);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        } else if (error.response && error.response.status === 400) {
          dispatch(setErrorMessage(error.response.data));
        } else {
          dispatch(setErrorMessage("An unexpected error occurred."));
        }
        setErrorDialogOpen(true);
      }
    },
    [dispatch]
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  useEffect(() => {
    dispatch(fetchJobTypes())
      .catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error fetching job types:', error);
      });
  }, [user_id,dispatch]);

  useEffect(() => {
    if (existingjobDetails && existingjobDetails.jobId) {
      setSelectedJobtype({
        id: existingjobDetails.jobTypeId,
        jobType: existingjobDetails.jobType,
      });
    }
    if (existingjobDetails?.meetingDetails) {
      const {
        meetingName,
        id: meetingId,
        subType: subtype,
        recordType,
        startDateTime,
        endDateTime,
        meetingStatus,
        deliveryFormat,
        oceStatus,
        ownerEmail,
        comments,
        estimatedParticipants,
      } = existingjobDetails.meetingDetails;

      setMeetingName(meetingName || "");
      setMeetingId(meetingId || "");
      setSubtype(subtype || "");
      setRecordType(recordType || "");
      setStartDateTime(dayjs(startDateTime) || dayjs().hour(12).minute(0));
      setEndDateTime(dayjs(endDateTime) || dayjs().hour(17).minute(0));
      setMeetingStatus("");
      setDeliveryFormat(deliveryFormat || "");
      setOceStatus("");
      setOwnerEmail(ownerEmail || "");
      setComments("");
      setEstimatedParticipants(0);
    }
  }, [existingjobDetails]);

  const jobType = useSelector((state) => state.fileUpload.jobTypes);
  const finalMapping = useSelector((state) => state.match.headerMapping);
  const jobInfo = useSelector((state) => state.fileUpload.selectedJob);
  const templateInfo = useSelector((state) => state.match.selectedTemplateType);
  //const user_id = useSelector((state) => state.login.user.id);
 
  // Removed console.log for production

  const handleMeetingErrors = () => {
    const newErrors = {};
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!meetingName) newErrors.meetingName = true;
    if (!recordType) newErrors.recordType = true;
    if (!subtype) newErrors.subtype = true;
    // if (!meetingStatus) newErrors.meetingStatus = true;
    if (!deliveryFormat) newErrors.deliveryFormat = true;
    if (!ownerEmail) {
      newErrors.ownerEmail = true;
    } else if (!emailPattern.test(ownerEmail)) {
      newErrors.ownerEmail = "Invalid email address";
    }
    // if (!estimatedParticipants) {
    //   newErrors.estimatedParticipants = true;
    // } else if (isNaN(estimatedParticipants)) {
    //   newErrors.estimatedParticipants = "Participants should be a number";
    // }
    if (!startDateTime) newErrors.startDateTime = true;
    if (!endDateTime) newErrors.endDateTime = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUploadData = () => {
    const newJob = {
      id: existingjobDetails?.jobId || 0,
      createdDate: new Date().toISOString(),
      jobName: fileObject.name.split(".")[0],
      jobType: jobInfo.jobType,
      fileName: fileObject.name,
      fileTemplate: templateInfo.templateName,
      status: "",
      jobTypeId: jobInfo.id,
      templateId: templateInfo.id,
      createdBy: user_id,
    };

    const requestBody = {
      job: newJob,
      selectedValues: finalMapping,
    };

    if (selectedJobtype.jobType === "IMC") {
      dispatch(
        uploadJobData({
          body: requestBody,
          file: fileObject,
        })
      ).catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error uploading IMC job:', error);
      });
    } else if (selectedJobtype.jobType === "Address") {
      dispatch(
        uploadJobData({
          body: requestBody,
          file: fileObject,
        })
      ).catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error uploading Address job:', error);
      });
    }
  };

  useEffect(() => {
    if (uploadedJobId) {
      const meetingDetails = {
        meetingId: meetingId,
        meetingName: meetingName,
        recordType: recordType,
        subType: subtype,
        startDateTime: startDateTime.toLocaleString(),
        endDateTime: endDateTime.toLocaleString(),
        meetingStatus: meetingStatus,
        deliveryFormat: deliveryFormat,
        oceStatus: oceStatus,
        ownerEmail: ownerEmail,
        comments: comments,
        estimatedParticipants: estimatedParticipants,
        jobId: uploadedJobId,
      };
      dispatch(submitMeetingDetails({ body: meetingDetails }))
        .catch((error) => {
          if (error?.response?.status === 401) {
            // Session expired, redirect will be handled by global event listener
            return;
          }
          console.error('Error submitting meeting details:', error);
        });
    }
  }, [uploadedJobId, meetingId, meetingName, recordType, subtype, startDateTime, endDateTime, meetingStatus, deliveryFormat, oceStatus, ownerEmail, comments, estimatedParticipants, dispatch]);
  

  useEffect(() => {
    if (uploadJobDataStatus === "succeeded") {
      //dispatch(resetUploadStatus());
      navigate("/custome-rmatch-portal");
      dispatch(resetUploadStatus());
    } else if (uploadJobDataStatus === "failed") {
      setDialogContent("File upload failed!");
      setErrorDialogOpen(true);
      //dispatch(resetUploadStatus());
    }
  }, [uploadJobDataStatus, dispatch, navigate]);

  const subtypeOptions = [
    "Webinar",
    "Chiesi – Dinner Mtg",
    "Sponsored – Dinner Mtg",
    "Conference",
    "Displays and Exhibits",
    "Hospital Mtg",
    "Adboard",
    "Journal Club",
    "Round table",
    "In-clinic Mtg",
  ];

  const recordTypeOptions = [
    "Displays & Exhibits",
    "HCP Sponsorship",
    "Rep Presentation",
    "Speaker Meeting",
    "Hybrid",
  ];

  const deliveryFormatOptions = ["In Person", "In Person & Virtual", "Virtual"];

  return (
    <>
      <div className="file-details">
        <FormControl>
          <InputLabel
            id="demo-simple-select-label"
            style={{ color: "#ab1368" }}
          >
            Job Type
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Job Type"
            value={jobInfo.id}
            onChange={handleChange}
            disabled={isDropdownDisabled}
            sx={commonStyles.select}
          >
            {jobType.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.jobType}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      {selectedJobtype.jobType === "Meeting" && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 2,
            border: "2px solid #ab1368",
            borderRadius: "8px",
            paddingBottom: "20px",
            paddingTop: "20px",
            maxWidth: "800px",
            width: "100%",
            margin: "0 auto",
          }}
        >
          <Grid container spacing={2} justifyContent="center">
            <div className="event-attendees-container">
              <Grid item xs={12} md={3}>
                <FormControl
                  sx={commonStyles.formControl}
                  error={errors.meetingName}
                >
                  <TextField
                    id="meeting-name"
                    label="Meeting Name"
                    variant="outlined"
                    value={meetingName}
                    onChange={(e) => setMeetingName(e.target.value)}
                  />
                  {errors.meetingName && (
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      Meeting Name is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControl sx={commonStyles.select} error={errors.recordType}>
                  <InputLabel
                    id="record-type-select-label"
                    style={{ color: "#ab1368" }}
                  >
                    Record Type
                  </InputLabel>
                  <Select
                    labelId="record-type-select-label"
                    id="record-type-select"
                    label="Record Type"
                    value={recordType}
                    onChange={(e) => setRecordType(e.target.value)}
                  >
                    {recordTypeOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.recordType && (
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      Record Type is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl sx={commonStyles.select} error={errors.subtype}>
                  <InputLabel
                    id="subtype-select-label"
                    style={{ color: "#ab1368" }}
                  >
                    SubType
                  </InputLabel>
                  <Select
                    labelId="subtype-select-label"
                    id="subtype-select"
                    label="Subtype"
                    value={subtype}
                    onChange={(e) => setSubtype(e.target.value)}
                  >
                    {subtypeOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.subtype && (
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      SubType is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControl
                  sx={commonStyles.select}
                  error={errors.deliveryFormat}
                >
                  <InputLabel
                    id="delivery-format-select-label"
                    style={{ color: "#ab1368" }}
                  >
                    Delivery Format
                  </InputLabel>
                  <Select
                    labelId="delivery-format-select-label"
                    id="delivery-format-select"
                    label="Delivery Format"
                    value={deliveryFormat}
                    onChange={(e) => setDeliveryFormat(e.target.value)}
                  >
                    {deliveryFormatOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.deliveryFormat && (
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      Delivery Format is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl
                  sx={commonStyles.formControl}
                  error={errors.ownerEmail}
                >
                  <TextField
                    id="ownerEmail"
                    label="Owner Email"
                    variant="outlined"
                    value={ownerEmail}
                    onChange={(e) => setOwnerEmail(e.target.value)}
                    error={!!errors.ownerEmail}
                    helperText={
                      errors.ownerEmail === true
                        ? "Email is required"
                        : errors.ownerEmail
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Start Date and Time"
                      value={startDateTime}
                      onChange={(newValue) => setStartDateTime(newValue)}
                      sx={commonStyles.formControl}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="End Date and Time"
                      value={endDateTime}
                      onChange={(newValue) => setEndDateTime(newValue)}
                      sx={commonStyles.formControl}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            </div>
            <div
              style={{
                marginTop: "16px",
                display: "flex",
                justifyContent: "center",
              }}
            ></div>
          </Grid>
        </Box>
      )}

      <div className="file-upload-container">
        <div
          className="dropzone-container"
          {...getRootProps({
            style: {
              width: "400px",
              height: "200px",
              border: "2px dashed #AB1368",
              fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
              borderRadius: "5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              padding: "20px",
            },
          })}
        >
          {uploadedFile ? (
            <p
              style={{
                textAlign: "center",
                margin: "0 auto",
              }}
            >
              File uploaded: {uploadedFile.name}
            </p>
          ) : (
            <p
              style={{
                fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
              }}
            >
              <FaUpload style={{ marginRight: "6px" }} />
              Drop your file here
            </p>
          )}
          <input {...getInputProps()} />
        </div>
      </div>
      <div className="progress-bar">
        {uploadProgress > 0 && !uploadedFile && (
          <Box sx={{ width: "35%", color: "#AB1368" }}>
            <LinearProgress color="inherit" value={uploadProgress} />
          </Box>
        )}
      </div>
      <div className="progress-bar">
        {uploadJobDataStatus === "loading" && (
          <Box sx={{ width: "35%", color: "#AB1368" }}>
            <LinearProgress color="inherit" value={uploadProgress} />
          </Box>
        )}
      </div>

      <div className="button-container">
        <div className="three-buttons">
          <div className="select-button">
            <Button
              {...getRootProps()}
              className="upload-button"
              variant="contained"
              component="button"
              sx={commonStyles.button}
            >
              Select File
            </Button>
          </div>
          {uploadedFile && jobInfo.id && (
            <div className="map-button">
              <Button
                variant="contained"
                component="button"
                sx={commonStyles.button}
                onClick={handleClickOpen}
              >
                Map Headers
              </Button>
              <Dialog fullScreen open={open} onClose={handleClose}>
                <DialogContent>
                  <DialogContentText>
                    <Match
                      clickToClose={handleClose}
                      initialMappingData={finalMapping}
                    />
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </div>
          )}
          {finalMapping.length > 0 && jobInfo.id && (
            <div className="upload-button">
              <Button
                variant="contained"
                component="button"
                sx={commonStyles.button}
                onClick={handleUploadData}
              >
                Upload Data
              </Button>
            </div>
          )}
        </div>
      </div>
      {uploadJobDataStatus === "failed" && (
        <Dialog open={errorDialogOpen} onClose={handleErrorDialogClose}>
          <DialogActions
            sx={{
              display: "flex",
              padding: "1px",
            }}
          >
            <IconButton
              color="inherit"
              onClick={handleErrorDialogClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
          <DialogContent>
            <h2 className="dialog-heading">Error</h2>
            <DialogContentText style={{ color: "#121212" }}>
              <p className="dialog-text">
                {uploadJobDataError}
              </p>
            </DialogContentText>
            <div className="submit-container">
              <Button
                type="submit"
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  backgroundColor: "#ab1368",
                  "&:hover": {
                    backgroundColor: "#8d0e56",
                  },
                }}
                onClick={handleErrorDialogClose}
              >
                Close
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
      <Dialog
        open={fileTypeErrorDialogOpen}
        onClose={handleFileTypeErrorDialogClose}
      >
        <DialogContent>
          <DialogContentText>
            Only Excel or CSV files are allowed.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: "5px",
          }}
        >
          <Button
            onClick={handleFileTypeErrorDialogClose}
            sx={{
              mt: 3,
              mb: 2,
              color: "white",
              backgroundColor: "#ab1368",
              "&:hover": {
                backgroundColor: "#8d0e56",
              },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FileUpload;
